import { Typography } from '@material-ui/core';

import {
  DialogComposite,
  MultiStepDialog,
  useFormField,
} from '@spotify/confidence-core-react';
import {
  MeasurementFormValues,
  MissingValuesForm,
  StepId,
} from '@spotify/plugin-confidence-metrics-react';

type MissingValuesStepProps = {
  stepId?: string;
};

export const MissingValuesStep = ({
  stepId = StepId.MissingValues,
}: MissingValuesStepProps) => {
  const { value, setValue } = useFormField<
    MeasurementFormValues,
    'nullHandling'
  >('nullHandling');

  return (
    <MultiStepDialog.Step id={stepId} optional>
      <MultiStepDialog.Header>
        <Typography variant="h4" component="h4">
          Missing values
        </Typography>
        <DialogComposite.Subtitle>
          Configure how to handle entities without data in the fact table.
        </DialogComposite.Subtitle>
      </MultiStepDialog.Header>
      <MultiStepDialog.Body>
        <MissingValuesForm value={value} onChange={setValue} />
      </MultiStepDialog.Body>
      <MultiStepDialog.Actions>
        <MultiStepDialog.Actions.Prev />
        <MultiStepDialog.Actions.Next />
      </MultiStepDialog.Actions>
    </MultiStepDialog.Step>
  );
};
